import { Drawer, Form, Input, Button, message } from "antd";
import { useEffect } from "react";
import api from "../../services/api";

export default function CategoryDrawer({ open, onClose, category, onSuccess }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (category) form.setFieldsValue(category);
    else form.resetFields();
  }, [category]);

  const submit = async () => {
    const values = await form.validateFields();

    if (category) {
      await api.put(`/categories/${category.id}`, values);
      message.success("Category updated");
    } else {
      await api.post("/categories", values);
      message.success("Category created");
    }

    onClose();
    onSuccess();
  };

  return (
    <Drawer
      title={category ? "Edit Category" : "Add Category"}
      open={open}
      onClose={onClose}
      width={360}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          name="name"
          label="Category Name"
          rules={[{ required: true }]}
        >
          <Input placeholder="Electronics" />
        </Form.Item>

        <Button type="primary" onClick={submit} block>
          Save
        </Button>
      </Form>
    </Drawer>
  );
}
